import React, { Component } from 'react';
import ErrorList from '../../components/ErrorList';

export default class VerificationCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            code: '',
            loading: false,
            seconds: 0,
            errors: [],
        };
    }

    resend() {
        this.props.resend();

        this.setState({
            seconds: window.VULOG_CONFIG.SMS_RESEND_SECONDS,
        });
        this.interval = setInterval(() => {
            if (this.state.seconds <= 0) {
                clearInterval(this.interval);
            }
            this.setState({
                seconds: this.state.seconds - 1,
            });
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    verify() {
        if (!this.state.code || this.state.code.length !== 6) {
            return this.setState({
                errors: [window.VULOG_TRANSLATE('code invalid')],
            });
        }

        this.setState({
            errors: [],
        });

        this.props.onVerify(this.state.code);
    }
    render() {
        return (
            <div className="e-modal__wrapper">
                <img
                    alt={'close'}
                    onClick={() => this.props.onRequestClose()}
                    style={{
                        position: 'relative',
                        top: 15,
                        right: 15,
                        float: 'right',
                    }}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEHSURBVEhL7ZVNCsIwEIXrz1HUYwiuBA8jbkU8h4ILxZ14J0X0DoKI+p5mIAzNJLZ1IfTBh3Uw81EzTbM6v0jbfaamCRqfy/SMwQ0sQIuFSLrgCA6gx0JKJuDpsQGWjJIzkN9fQAeYYcM78EUkJGNDXyIsQTQroBcSLQtJrqAPomEzNtUNiMgsyRAkx5LtQSUSiSXTFJZIUmSlJRLKdiBP8gAjUElCGy/IgJRKTCKUkuknXuDfpWukkCwk4cZzT9ZezecrmSWR6WKz0DQmyXjM8xTWi/NG2JLNgBm+U07AX2Q9JyHZFETD9wmP+phEomVbV0sKx5pH/eD9LR425l3M3XWdv0uWvQDq/6w9IEeDKwAAAABJRU5ErkJggg=="
                />
                <div className="e-modal__head">
                    <h2 className="e-modal__title">{window.VULOG_TRANSLATE('2 Factor Authentication')}</h2>
                </div>

                <div className="e-modal__body">
                    <div className="f-section">
                        <ErrorList errors={[...this.props.errors, ...this.state.errors].filter(e => !!e)} />
                        <div>
                            <p className="page__description" style={{ display: 'block', lineHeight: 2 }}>
                                {window.VULOG_TRANSLATE(
                                    'Please enter the six-digit code that was sent to your number:'
                                )}{' '}
                                <b>+{this.props.phoneNumber}</b>
                            </p>

                            <div className="form-row mb-4">
                                <div className="col">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="\d*"
                                        maxLength={6}
                                        className="form-control"
                                        id="verification-code"
                                        autoComplete="one-time-code"
                                        value={this.state.code}
                                        onChange={e => this.setState({ code: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="d-flex flex-row mt-auto mb-1-5rem">
                                <button
                                    disabled={this.state.seconds > 0}
                                    className="btn btn-primary btn-block"
                                    onClick={() => this.resend()}
                                >
                                    {this.state.seconds > 0 ? this.state.seconds : window.VULOG_TRANSLATE('RESEND')}
                                </button>
                                <button className="btn btn-primary btn-block" onClick={() => this.verify()}>
                                    {window.VULOG_TRANSLATE('Next')}
                                    <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
